export const FAVORITE_MARKETS_THROTTLE_MS = 100;

export const DISPLAY_OPTIONS = [
  { label: "$", value: "price" as const, "data-testid": "favorite-markets:display-price" },
  { label: "%", value: "percent" as const, "data-testid": "favorite-markets:display-percent" },
];
